import {defineAsyncComponent} from "vue";

// The shared, token-driven slots every new theme renders (WEB_V2_BUILD.md §4).
// Themes differ through their tokens (catalogueData.js) and the scoped CSS in
// ../theme.css, not through per-theme components.
export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    hero: defineAsyncComponent(() => import("./Hero.vue")),
    nav: defineAsyncComponent(() => import("../nav/SiteHeader.vue")),
    footer: defineAsyncComponent(() => import("../footer/SiteFooter.vue")),
};
